window.arPurchaseInvoiceDownloadFormatter = function(value, row) {
    let html = '';
    html += '<a href="/ar/purchase/invoices/download/'+row.id+'">';
    html += '<i class="fa fa-download"></i>';
    html += '</a>';
    return html;
}
